<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="4" xl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-calendar"></i>&nbsp;Ventas</b>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol
                xs="12"
                sm="6"
                md="6"
                lg="12"
                v-if="$store.getters.get_rol.id !== 7"
              >
                <CSelect
                  label="Sede: "
                  :value.sync="campu_id"
                  :options="data_campus"
                  placeholder="--Seleccione una sede--"
                  @change="handleCampusChange"
                />
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CInput
                  label="Desde"
                  type="date"
                  aria-label="shift_date"
                  @input="mtd_data"
                  size="sm"
                  id="init"
                  v-model="filter.init"
                />
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CInput
                  label="Hasta"
                  type="date"
                  aria-label="shift_date"
                  @input="mtd_data"
                  id="end"
                  size="sm"
                  v-model="filter.end"
                />
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CInput
                  label="Cantidad de Ventas"
                  type="text"
                  size="sm"
                  v-model="totalVentas"
                  disabled
                />
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CInput
                  label="Total de Ventas"
                  type="text"
                  size="sm"
                  v-model="sumaTotalVentas"
                  disabled
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="8" xl="9">
        <CTableWrapper
          v-if="showSalesTable"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          :items="data_sale_products"
          small
          fixed
          billing
          caption="Lista de ventas de productos"
          icon="fas fa-coins"
          @mtdBack="mtdBack"
          @mtdReport="mtdReport"
          :size="'md'"
          :actions="true"
          :myButtons="myButtons"
          @mtd_ticket="mtd_ticket"
          :withActions="'2%'"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "campus_name", label: "Sede", _style: "width:10%;" },
  { key: "client_name", label: "Cliente", _style: "width:10%;" },
  { key: "date_formatted", label: "Fecha", _style: "width:10%;" },
  { key: "method_payment_text", label: "Método de pago", _style: "width:10%;" },
  { key: "tipo_comprobante", label: "Tipo de comprobante", _style: "width:10%;" },
  { key: "serie", label: "Vouchers", _style: "width:10%;" },
  // { key: "correlativo", label: "Correlativo", _style: "width:10%;" },
  { key: "detail_sale", label: "Productos", _style: "width:10%;" },
  { key: "subtotal", label: "SubTotal", _style: "width:5%;" },
  { key: "ajustement_amount", label: "Descuento", _style: "width:5%;" },
  { key: "alltotal", label: "Total/Pagado", _style: "width:5%;" },
  { key: "ajustement_motive", label: "Observación", _style: "width:10%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../../../components/shared/datatable/Table.vue";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  components: {
    CTableWrapper,
  },
  data() {
    return {
      prefix: "sales",
      fields,
      // sale_products,
      totalVentas: 0,
      sumaTotalVentas: 0,
      data: [],
      // data_sale_quotes: [],
      data_sale_products: [],
      filter: {
        init: null,
        end: null,
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      showSalesTable: true,
      myButtons: [
        {
          class: "btn-sm",
          color: "danger",
          tooltip: "Ticket",
          action: "mtd_ticket",
          icon: "fas fa-file-pdf",
        },
      ],
      data_campus: [],
      campu_id: 0,
    };
  },
  computed: {
    cpStatus: function () {
      if (this.companies.state == 1) return true;
      return false;
    },
  },
  created() {
    this.getCampus();
    moment.locale("es");
    this.filter.end = moment().format("YYYY-MM-DD");
    this.filter.init = this.filter.end;
    this.mtd_data();
  },
  methods: {
    ...mapActions(["get", "post"]),

    handleCampusChange() {
      this.mtd_data();
    },

    mtd_data() {
      if (
        !this.filter.init ||
        !this.filter.end ||
        this.filter.init > this.filter.end
      ) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Por favor, selecciona un rango de fechas válido.",
        });
      }
      let campu_id =
        this.$store.getters.get_rol.id == 7
          ? this.$store.getters.get_campu.id
          : this.campu_id;
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/indexSale",
        token: this.$store.getters.get__token,
        params: {
          init: this.filter.init,
          end: this.filter.end,
          campu_id: campu_id,
        },
      })
        .then((response) => {
          this.data = response.data;
          this.data_sale_products = this.data.filter((item) => item.type == 0);
          this.totalVentas = this.data.filter(item => item.voucher[0].state != 2).length;
          this.sumaTotalVentas = this.data
              .reduce((sum, item) => {
                if (item.voucher[0].state == 2) return sum;
                return sum + parseFloat(item.amount || 0);
              }, 0)
              .toFixed(2);

          let index = 1;

          this.data.forEach((item) => {            
            item.subtotal = item.total;
            item.alltotal =
              item.state == 1
                ? (
                    parseFloat(item.total) + parseFloat(item.ajustement_amount)
                  ).toFixed(2)
                : item.amount;
            item.index = index++;
            item.ajustement_motive = item.ajustement_motive || '';
            item.campus_name = item.campu?.name || "No especificado";
            item.client_name = item.client?.name || "No especificado";
            item.date_formatted = moment(item.date).format("DD/MM/YYYY");
            if (item.voucher.length == 1) {
              item.serie = ( item.voucher[0]?.serie || "-")+"-"+( item.voucher[0]?.number || "-");
            }else{
              let series = "";
              item.voucher.forEach(ele => {
                series += ele.serie+"-"+ele.number+", ";
              });
              item.serie = series || "-";
            }
            // item.correlativo = item.voucher[0]?.number || "-";
            /* item.detail_sale = item.detail
              .map((det) =>
                det.product
                  ? `${det.product.name} (${det.quantity})`
                  : "Producto no encontrado"
              )
              .join(", "); */
            item.detail_sale = item.detail.map((det) => {
              if (det.product && det.product != null) {
                return `[Pro] ${det.product.name} (${det.quantity})`;
              } else if (det.production && det.production != null) {
                return `[PP] ${det.production.name}`;
              } else {
                return "Item no encontrado";
              }
            }).join(", ");
            item.method_payment_text = item.method_payment?.name || "No especificado";
            /* if (item.method_payment && item.method_payment.name) {
              item.method_payment_text = item.method_payment.name;
            } else {
              item.method_payment_text = "No especificado";
            } */
            item.tipo_comprobante= item.voucher[0].document_type.name || 'No especificado';

            const resState = String(item?.state);

            switch (resState) {
              case '0':
                item.status = "Cancelado";
                break;
              case '1':
                item.status = "Pagado";
                break;
              case '2':
                item.status = "Pendiente";
                break;
              default:
                item.status = "Desconocido";
            }
            if (item.voucher[0].state == 2) {
              item.status += " - ANULADO";
            }
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_ticket(item) {
      if (item.voucher.length == 1) {
        if (item?.voucher?.[0]?.id && item?.voucher?.[0]?.detail) {
          const voucher = item.voucher[0].id;
          // const idProduct = item.voucher[0].detail;
          const document_name = item.voucher[0].document_type.name;
          if (document_name == "NOTA DE VENTA") {
            window.open(
              this.$store.getters.get__url +
                "/sales/ticket/" +
                voucher +
                // "/" +
                // idProduct +
                "/" +
                this.$store.getters.get__user_id,
              "_blank"
            );
          } else {
            const sunatData = JSON.parse(item.voucher[0].sunat);
            const ticketUrl = sunatData?.json?.enlace_del_pdf_ticket;
            window.open(ticketUrl, "_blank");
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Ticket",
            text: "Esta venta todavía no tiene documento",
          });
        }
      } else {
        item.voucher.forEach(element => {
          const voucher = element.id;
          // const idProduct = item.voucher[0].detail;
          const document_name = element.document_type.name;
          if (document_name == "NOTA DE VENTA") {
            window.open(
              this.$store.getters.get__url +
                "/sales/ticket/" +
                voucher +
                // "/" +
                // idProduct +
                "/" +
                this.$store.getters.get__user_id,
              "_blank"
            );
          } else {
            const sunatData = JSON.parse(element.sunat);
            const ticketUrl = sunatData?.json?.enlace_del_pdf_ticket;
            window.open(ticketUrl, "_blank");
          }
        });
      }
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    getCampus() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/users/bycampus/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode == 200) {
          this.data_campus.push({
            label: "Todos",
            value: 0,
          });

          response.data.forEach((element) => {
            this.data_campus.push({
              label: element.name,
              value: element.id,
            });
          });
        }
      });
    },
    mtdReport: async function() {
      try {
        const ExcelJS = require('exceljs');
        const { saveAs } = require('file-saver');

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Ventas');

        const columns = [
          { header: 'ID', key: 'id', width: 5 },
          { header: 'SEDE', key: 'campus_name', width: 15 },
          { header: 'CLIENTE', key: 'client_name', width: 25 },
          { header: 'FECHA', key: 'date_formatted', width: 12 },
          { header: 'TIPO DE COMPROBANTE', key: 'tipo_comprobante', width: 25 },
          { header: 'SERIE', key: 'serie', width: 15 },
          { header: 'CORRELATIVO', key: 'correlativo', width: 15 },
          { header: 'MÉTODO DE PAGO', key: 'method_payment_text', width: 15 },
          { header: 'PRODUCTOS', key: 'detail_sale', width: 40 },
          { header: 'SUBTOTAL', key: 'subtotal', width: 12 },
          { header: 'DESCUENTO', key: 'ajustement_amount', width: 12 },
          { header: 'TOTAL', key: 'alltotal', width: 12 },
          { header: 'ESTADO', key: 'status', width: 12 },
        ];

        worksheet.columns = columns;

        const headerRow = worksheet.getRow(1);
        headerRow.font = { bold: true };
        headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9E1F2' } };
        headerRow.alignment = { horizontal: 'center', vertical: 'center', wrapText: true };

        headerRow.eachCell((cell) => {
          cell.border = {
            top:    { style: 'thin' },
            left:   { style: 'thin' },
            bottom: { style: 'thin' },
            right:  { style: 'thin' }
          };
        });

        this.data_sale_products.forEach((item, index) => {
          const row = worksheet.addRow({
            id: index + 1,
            campus_name: item.campu?.name || '-',
            client_name: item.client?.name || 'Sin nombre',
            date_formatted: item.date_formatted,
            tipo_comprobante: item.voucher[0]?.document_type.name || '-',
            serie: item.voucher[0]?.serie || '-',
            correlativo: item.voucher[0]?.number || '-',
            method_payment_text: item.method_payment?.name || '-',
            detail_sale: item.detail_sale || '-',
            subtotal: parseFloat(item.subtotal || 0),
            ajustement_amount: parseFloat(item.ajustement_amount || 0),
            alltotal: parseFloat(item.alltotal || 0),
            status: item.status || '-',
          });

          row.eachCell((cell) => {
            cell.border = {
              top:    { style: 'thin' },
              left:   { style: 'thin' },
              bottom: { style: 'thin' },
              right:  { style: 'thin' }
            };
          });
        });


        ['J', 'K', 'L'].forEach(col => {
          worksheet.getColumn(col).numFmt = '#,##0.00';
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        saveAs(blob, `Reporte_Ventas_${this.filter.init}_al_${this.filter.end}.xlsx`);

      } catch (error) {
        console.error("Error al generar reporte:", error);
        Swal.fire({
          title: "Error al generar el reporte",
          text: error.message,
          icon: "error"
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.custom-button:hover {
  background-color: #7e4bbf !important;
  border-color: #7e4bbf !important;
}
</style>
